<template>
  <b-modal
    v-model="show"
    header-bg-variant="primary"
    header-text-variant="light"
    title="Create Matchfight"
    no-close-on-backdrop
    no-close-on-esc
    @close.prevent="close"
  >
    <div class="form-group">
      <label for="redCorner">Red Corner</label>
      <select class="custom-select" id="redCorner" v-model="fight.athleteRed">
        <option v-for="a in freeAthletesRed" :key="a.id" :value="a">
            {{ a.name }} [{{ a.team }}] - {{ a.weight }} kg
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="blueCorner">Blue Corner</label>
      <select class="custom-select" id="blueCorner" v-model="fight.athleteBlue">
        <option v-for="a in freeAthletesBlue" :key="a.id" :value="a">
            {{ a.name }} [{{ a.team }}] - {{ a.weight }} kg
        </option>
      </select>
    </div>
    <b-button variant="info" size="sm" class="mr-2" @click="switchCorners">Switch</b-button>
    <b-button variant="warning" size="sm" @click="clearCorners">Clear</b-button>
    <hr>
    <b-form-select
      :options="weightClasses"
      text-field="stringDe"
      value-field="weight"
      v-model="fight.weightClass"
    />
    <div>
      <label>Rules</label>
      <b-form-select :options="typeSelect" v-model="fight.type"/>
    </div>
    <b-row>
      <b-col>
        <label>Rounds</label>
        <b-form-select :options="roundsSelect" v-model="fight.rounds"/>
      </b-col>
      <b-col>
        <label>Duration</label>
        <b-form-select :options="durationSelect" v-model="fight.duration"/>
      </b-col>
    </b-row>
    <div>
      <label>Extra time</label>
      <div class="d-flex">
        <b-button @click="decreaseExtraTime">-</b-button>
        <input
          class="form-control"
          disabled
          :value="formattedTime(fight.extraTime)"
        />
        <b-button @click="increaseExtraTime">+</b-button>
      </div>
    </div>
    <ul class="mt-3">
      <li v-for="e in errors" :key="e" class="text-danger">{{ e }}</li>
    </ul>
    <template v-slot:modal-footer>
      <b-button variant="primary" @click="create">Create</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'MatchFightCreateModal',
  props: ['show'],
  data() {
    return {
      errors: [],
      fight: {},
      durationSelect: [
        { value: 300, text: '5:00' },
        { value: 180, text: '3:00' },
        { value: 120, text: '2:00' },
      ],
      roundsSelect: [5, 3, 2],
      typeSelect: ['amateur', 'pro'],
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    create() {
      if (this.hasErrors()) return;
      this.$store.commit('createMatchFight', this.fight);
      this.$store.commit('removeMatchFightAthleteFromUnassigned', this.fight.athleteBlue.id);
      this.$store.commit('removeMatchFightAthleteFromUnassigned', this.fight.athleteRed.id);
      this.resetFight();
      this.$emit('close');
    },
    clearCorners() {
      this.fight.athleteBlue = {};
      this.fight.athleteRed = {};
    },
    decreaseExtraTime() {
      this.fight.extraTime = parseInt(this.fight.extraTime, 10) - 60;
    },
    formattedTime(value) {
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    },
    hasErrors() {
      this.errors = [];
      if (this.fight.athleteRed === undefined || this.fight.athleteRed.id === undefined) {
        this.errors.push('Select Red Corner');
      }
      if (this.fight.athleteBlue === undefined || this.fight.athleteBlue.id === undefined) {
        this.errors.push('Select Blue Corner');
      }
      if (!this.fight.weightClass) this.errors.push('Select weight class');
      return this.errors.length > 0;
    },
    increaseExtraTime() {
      this.fight.extraTime = parseInt(this.fight.extraTime, 10) + 60;
    },
    resetFight() {
      this.fight = {
        athleteRed: {},
        athleteBlue: {},
        duration: 300,
        extraTime: 300,
        rounds: 3,
        type: 'pro',
        weightClass: null,
      };
    },
    switchCorners() {
      [this.fight.athleteBlue, this.fight.athleteRed] = [
        this.fight.athleteRed, this.fight.athleteBlue];
    },
  },
  computed: {
    athletes() {
      return this.$store.state.setup.matchFights.athletes;
    },
    freeAthletesBlue() {
      if (this.fight.athleteRed) {
        return this.athletes.filter((a) => a.id !== this.fight.athleteRed.id);
      }
      return this.athletes;
    },
    freeAthletesRed() {
      if (this.fight.athleteBlue) {
        return this.athletes.filter((a) => a.id !== this.fight.athleteBlue.id);
      }
      return this.athletes;
    },
    weightClasses() {
      return this.$weightClasses();
    },
  },
  created() {
    this.resetFight();
  },
};
</script>

<style scoped>

</style>
